/** 밀리초 단위 시간 상수 */
export const SECOND = 1000
export const MINUTE = 60 * SECOND
export const HOUR = 60 * MINUTE
export const TEST_TIME = MINUTE * 3
